// PLP Back-button restore
// "Show More" on collection pages appends products with JS, which the browser
// doesn't remember. When a shopper opens a product and presses Back, the page
// reloads with only the first batch and the scroll jumps to the top or bottom.
// This saves what was loaded + where the shopper was (in the history entry
// itself, so a fresh visit to the collection starts clean), and on Back loads
// the same products again and scrolls back to the same product.
//
// It also runs the "Show More" buttons on the smaller collection rows under the
// main grid. main.js loaded their page 2 first, but those rows only show 6 of
// page 1's 12 items, so items 7-12 of every row were never shown. The same
// rows on the homepage get the same restore, so a refresh there no longer
// lands on the footer.
(function () {
  var container = document.querySelector(".main-loop");
  var loop = container && container.querySelector(".loop");
  var handle = container && container.getAttribute("data-collection-handle");

  // The homepage has no main grid, only rows; treat a partial grid as none.
  if (!container || !loop || !handle) {
    container = loop = handle = null;
  }

  if ((!container && !document.querySelector(".show-more-collection")) || !window.history || !history.replaceState) {
    return;
  }

  var STATE_KEY = "bcPlp";
  var VIEW_CLASSES = ["toggle-one", "toggle-two"];
  var ROW_STEP = 12;

  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  function readState() {
    var state = history.state;
    return state && typeof state === "object" ? state[STATE_KEY] || null : null;
  }

  function writeState(extra) {
    try {
      var state = history.state && typeof history.state === "object" ? history.state : {};
      var next = Object.assign({}, state);
      next[STATE_KEY] = Object.assign({}, state[STATE_KEY] || {}, extra);
      history.replaceState(next, "");
    } catch (error) {
      // Safari throttles replaceState; losing one save is harmless.
    }
  }

  function currentPage() {
    if (!container) {
      return 1;
    }
    var page = parseInt(container.getAttribute("data-current-page"), 10);
    return isNaN(page) ? 1 : page;
  }

  function currentView() {
    if (!loop) {
      return "";
    }
    for (var i = 0; i < VIEW_CLASSES.length; i++) {
      if (loop.classList.contains(VIEW_CLASSES[i])) {
        return VIEW_CLASSES[i];
      }
    }
    return "";
  }

  // Same product key main.js uses to de-duplicate cards.
  function getProductKey(item) {
    var el = item.matches("[data-product-id], [data-product-handle]")
      ? item
      : item.querySelector("[data-product-id], [data-product-handle]");

    if (el) {
      return el.getAttribute("data-product-id") || el.getAttribute("data-product-handle");
    }

    var link = item.matches("a[href*='/products/']")
      ? item
      : item.querySelector("a[href*='/products/']");

    return link ? link.getAttribute("href").split("?")[0] : null;
  }

  function shownKeys(list) {
    var keys = new Set();
    Array.prototype.forEach.call(list.children, function (item) {
      var key = getProductKey(item);
      if (key) {
        keys.add(key);
      }
    });
    return keys;
  }

  var params = new URLSearchParams(window.location.search);
  var sortBy = params.get("sort_by") || (container && container.getAttribute("data-sort-by")) || "";

  function fetchProducts(collectionHandle, view, page, sort) {
    var q = new URLSearchParams();
    q.set("view", view);
    q.set("page", page);
    if (sort) {
      q.set("sort_by", sort);
    }
    return fetch("/collections/" + collectionHandle + "?" + q.toString())
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Failed to load products");
        }
        return response.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, "text/html").querySelector(".ajax-products");
      });
  }

  // --- Collection rows under the main grid ---
  var rows = Array.prototype.slice.call(document.querySelectorAll(".show-more-collection")).map(function (row) {
    var rowLoop = row.querySelector(".show-more-loop");
    var oldBtn = row.querySelector(".show-more-btn");
    var rowHandle = row.getAttribute("data-collection-handle");

    if (!rowLoop || !oldBtn || !rowHandle) {
      return null;
    }

    // Swap the button for a copy to drop main.js's click handler.
    var btn = oldBtn.cloneNode(true);
    oldBtn.parentNode.replaceChild(btn, oldBtn);

    var rs = { row: row, loop: rowLoop, btn: btn, handle: rowHandle, nextPage: 1, buffer: [], done: false, clicks: 0, busy: false };

    btn.addEventListener("click", function (event) {
      event.preventDefault();
      if (rs.busy) {
        return;
      }
      rs.busy = true;
      btn.disabled = true;
      btn.textContent = "Loading...";
      loadRowStep(rs)
        .then(function () {
          rs.clicks++;
          btn.textContent = "Show More";
          saveScroll();
        })
        .catch(function (error) {
          console.error(error);
          btn.textContent = "Try Again";
        })
        .then(function () {
          rs.busy = false;
          btn.disabled = false;
        });
    });

    return rs;
  });

  // Adds the next 12 products the row isn't showing yet, walking the
  // collection's pages from the start so nothing is skipped or repeated.
  function loadRowStep(rs) {
    var shown = shownKeys(rs.loop);
    var added = 0;

    function take() {
      while (rs.buffer.length && added < ROW_STEP) {
        var item = rs.buffer.shift();
        var key = getProductKey(item);
        if (key && shown.has(key)) {
          continue;
        }
        rs.loop.appendChild(item);
        if (key) {
          shown.add(key);
        }
        added++;
      }

      if (added >= ROW_STEP || rs.done) {
        return Promise.resolve();
      }

      return fetchProducts(rs.handle, "ajax-show-more", rs.nextPage, "").then(function (ajax) {
        rs.nextPage++;
        if (!ajax) {
          rs.done = true;
          return;
        }
        var temp = document.createElement("div");
        temp.innerHTML = ajax.innerHTML;
        rs.buffer = rs.buffer.concat(Array.prototype.slice.call(temp.children));
        if (ajax.getAttribute("data-has-next-page") !== "true") {
          rs.done = true;
        }
        return take();
      });
    }

    return take().then(function () {
      rs.buffer = rs.buffer.filter(function (item) {
        var key = getProductKey(item);
        return !(key && shown.has(key));
      });

      if (typeof initAjaxProductCards === "function") {
        initAjaxProductCards(rs.row);
      }

      if (rs.done && !rs.buffer.length) {
        var viewAll = rs.row.querySelector(".view-all-btn");
        rs.btn.remove();
        if (viewAll) {
          viewAll.remove();
        }
      }
    });
  }

  // --- Where the shopper is ---
  // Product lists in page order: the main grid, then each row.
  function lists() {
    return [loop].concat(rows.map(function (rs) { return rs ? rs.loop : null; }));
  }

  // The topmost product on screen, which list it's in, and how far from the
  // top it sits. More reliable than raw scrollY if heights shift.
  function getAnchor() {
    var all = lists();
    for (var l = 0; l < all.length; l++) {
      if (!all[l]) {
        continue;
      }
      var items = all[l].children;
      for (var i = 0; i < items.length; i++) {
        var rect = items[i].getBoundingClientRect();
        if (rect.bottom > 0) {
          if (rect.top < window.innerHeight) {
            return { anchorList: l, anchorKey: getProductKey(items[i]), anchorTop: rect.top };
          }
          break;
        }
      }
    }
    return { anchorList: null, anchorKey: null, anchorTop: 0 };
  }

  var restoring = false;

  function saveScroll() {
    if (restoring) {
      return;
    }
    var anchor = getAnchor();
    writeState({
      page: currentPage(),
      rows: rows.map(function (rs) { return rs ? rs.clicks : 0; }),
      y: window.scrollY,
      anchorList: anchor.anchorList,
      anchorKey: anchor.anchorKey,
      anchorTop: anchor.anchorTop,
      view: currentView(),
      docHeight: document.documentElement.scrollHeight,
    });
  }

  var scrollTimer = null;
  window.addEventListener(
    "scroll",
    function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(saveScroll, 250);
    },
    { passive: true }
  );

  // Save right before the shopper leaves (tap on a product, or any exit).
  document.addEventListener("click", function (event) {
    if (event.target.closest && event.target.closest("a[href]")) {
      saveScroll();
    }
  }, true);
  window.addEventListener("pagehide", saveScroll);

  // main.js bumps data-current-page after each "Show More"; Toggle View
  // changes the grid's class. Save whenever either happens.
  if (container) {
    new MutationObserver(saveScroll).observe(container, {
      attributes: true,
      attributeFilter: ["data-current-page"],
    });
    new MutationObserver(saveScroll).observe(loop, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  function scrollToState(s) {
    var y = s.y || 0;
    var list = s.anchorList != null ? lists()[s.anchorList] : null;
    if (list && s.anchorKey) {
      var items = list.children;
      for (var i = 0; i < items.length; i++) {
        if (getProductKey(items[i]) === s.anchorKey) {
          y = window.scrollY + items[i].getBoundingClientRect().top - (s.anchorTop || 0);
          break;
        }
      }
    }
    window.scrollTo(0, Math.max(0, y));
  }

  // iPhone Safari usually brings the page back from memory on Back (swipe or
  // button) with every product still loaded, so this script doesn't run again.
  // Because scroll restoration is manual, it lands at the top: put the shopper
  // back where they were.
  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) {
      return;
    }
    var s = readState();
    if (!s) {
      return;
    }
    scrollToState(s);
    requestAnimationFrame(function () { scrollToState(s); });
  });

  // --- Restoring after Back ---
  var saved = readState();

  if (!saved) {
    return;
  }

  var userMoved = false;
  ["wheel", "touchstart", "keydown"].forEach(function (type) {
    window.addEventListener(type, function () { userMoved = true; }, { passive: true, once: true });
  });

  function scrollToSaved() {
    if (userMoved) {
      return;
    }
    scrollToState(saved);
  }

  // Browsers' scroll anchoring nudges the page while cards are inserted above
  // the saved spot; switch it off for the few moments the restore takes.
  function setScrollAnchoring(on) {
    [document.documentElement, document.body].forEach(function (el) {
      if (el) {
        el.style.overflowAnchor = on ? "" : "none";
      }
    });
  }

  function finishRestore() {
    document.body.style.minHeight = "";
    scrollToSaved();
    requestAnimationFrame(function () {
      scrollToSaved();
      setScrollAnchoring(true);
    });
    if (document.readyState !== "complete") {
      window.addEventListener("load", scrollToSaved, { once: true });
    }
    restoring = false;
  }

  if (loop && saved.view && VIEW_CLASSES.indexOf(saved.view) !== -1 && !loop.classList.contains(saved.view)) {
    VIEW_CLASSES.forEach(function (c) { loop.classList.remove(c); });
    loop.classList.add(saved.view);
  }

  var tasks = [];

  // Main grid: load the pages the shopper had, a few at a time, in order.
  var startPage = currentPage();
  var targetPage = parseInt(saved.page, 10) || startPage;

  if (container && targetPage > startPage) {
    var buttons = container.querySelectorAll(".show-more-btn, .view-all-btn");
    var showMoreBtn = container.querySelector(".show-more-btn");
    Array.prototype.forEach.call(buttons, function (btn) { btn.disabled = true; });
    if (showMoreBtn) {
      showMoreBtn.textContent = "Loading...";
    }

    var pages = [];
    for (var p = startPage + 1; p <= targetPage; p++) {
      pages.push(p);
    }

    var results = {};
    var cursor = 0;

    var worker = function () {
      if (cursor >= pages.length) {
        return Promise.resolve();
      }
      var page = pages[cursor++];
      return fetchProducts(handle, "ajax-main", page, sortBy).then(function (ajax) {
        results[page] = ajax;
        return worker();
      });
    };

    var workers = [];
    for (var w = 0; w < Math.min(4, pages.length); w++) {
      workers.push(worker());
    }

    tasks.push(
      Promise.all(workers)
        .then(function () {
          var existing = shownKeys(loop);
          var lastLoaded = startPage;
          var hasNext = true;

          for (var i = 0; i < pages.length; i++) {
            var ajax = results[pages[i]];
            if (!ajax) {
              hasNext = false;
              break;
            }
            var temp = document.createElement("div");
            temp.innerHTML = ajax.innerHTML;
            Array.prototype.slice.call(temp.children).forEach(function (item) {
              var key = getProductKey(item);
              if (key && existing.has(key)) {
                return;
              }
              loop.appendChild(item);
              if (key) {
                existing.add(key);
              }
            });
            lastLoaded = pages[i];
            hasNext = ajax.getAttribute("data-has-next-page") === "true";
          }

          container.setAttribute("data-current-page", lastLoaded);
          var counter = container.querySelector(".current-page");
          if (counter) {
            counter.textContent = lastLoaded;
          }

          if (typeof initAjaxProductCards === "function") {
            initAjaxProductCards(container);
          }

          if (!hasNext) {
            Array.prototype.forEach.call(buttons, function (btn) { btn.remove(); });
          } else {
            Array.prototype.forEach.call(buttons, function (btn) { btn.disabled = false; });
            if (showMoreBtn) {
              showMoreBtn.textContent = "Show More";
            }
          }
        })
        .catch(function (error) {
          console.error(error);
          Array.prototype.forEach.call(buttons, function (btn) { btn.disabled = false; });
          if (showMoreBtn) {
            showMoreBtn.textContent = "Show More";
          }
        })
    );
  }

  // Rows: repeat the same number of "Show More" steps.
  (saved.rows || []).forEach(function (clicks, index) {
    var rs = rows[index];
    if (!rs || !clicks) {
      return;
    }
    rs.busy = true;
    rs.btn.disabled = true;
    rs.btn.textContent = "Loading...";

    var chain = Promise.resolve();
    for (var c = 0; c < clicks; c++) {
      chain = chain.then(function () {
        if (rs.done && !rs.buffer.length) {
          return;
        }
        return loadRowStep(rs).then(function () { rs.clicks++; });
      });
    }

    tasks.push(
      chain
        .catch(function (error) {
          console.error(error);
        })
        .then(function () {
          rs.busy = false;
          rs.btn.disabled = false;
          rs.btn.textContent = "Show More";
        })
    );
  });

  if (!tasks.length) {
    finishRestore();
    return;
  }

  restoring = true;
  setScrollAnchoring(false);

  // Hold the old page height so the browser can jump to the right spot at once.
  if (saved.docHeight) {
    document.body.style.minHeight = saved.docHeight + "px";
  }
  window.scrollTo(0, saved.y || 0);

  Promise.all(tasks).then(function () {
    // MutationObserver callbacks run as microtasks; let them pass first.
    setTimeout(finishRestore, 0);
  });
})();
